module.exports = __webpack_public_path__ + "img/logo-header.fac3db7e.png";